<template>
  <div>
    <v-btn @click="login" :loading="isLoggedIn">Login</v-btn>
  </div>
</template>
<script>
import debounce from "lodash.debounce";

export default {
  name: "Login",
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    // Don't auto-login on mount, let the user click the button
    if (this.$azure.isLoggedIn()) {
      if (this.$azure.isLoginExpired()) {
        this.$azure.refreshToken(() => this.$router.push("/"));
      } else {
        this.$router.push("/");
      }
    }
  },
  methods: {
    login() {
      this.$azure.login();
    },
    delayedLogin: debounce(
      function () {
        // nur nen test...
        this.$azure.login();
      },
      1000,
      { leading: false, trailing: true }
    ),
    redirect: debounce(
      function () {
        window.location = this.origin;
      },
      1000,
      { leading: false, trailing: true }
    ),
  },
  computed: {
    isLoggedIn() {
      return this.$azure.isLoggedIn();
    },
  },
};
</script>
